export default "__VITE_ASSET___V8heAYP__"